import { render } from "./FloatingCart.vue?vue&type=template&id=5e5f7c69&scoped=true"
import script from "./FloatingCart.vue?vue&type=script&lang=js"
export * from "./FloatingCart.vue?vue&type=script&lang=js"

import "./FloatingCart.vue?vue&type=style&index=0&id=5e5f7c69&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5f7c69"]])

export default __exports__